import { ConfigProvider, Spin } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $loading, initCHStoreEv } from './models/centerHomeModel/index.js';

export const CHTheme = {
  token: {
    colorPrimary: '#27ae60',
  },
  components: {
    Select: {
      multipleItemBg: '#e9f7ef',
    },
  },
};

function App() {
  const loading = useUnit($loading);
  const initCHStore = useUnit(initCHStoreEv);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname !== '/center-home') {
      navigate('/center-home');
    }
    initCHStoreEv();
  }, []);

  return (
    <ConfigProvider theme={CHTheme}>
      <Spin spinning={loading}>
        <Outlet />
      </Spin>
    </ConfigProvider>
  );
}

export default App;
